import NBType, { InferType } from '@netbase/nb-type'
import MetricTimeUnit from '../enums/MetricTimeUnit'
import TimelineAnnotationGroupSchema from './TimelineAnnotationGroupSchema'
import TimelineSeriesSchema from './TimelineSeriesSchema'

const TimelineDataSchema = NBType.object().shape('TimelineDataSchema', {
  /* @prop */
  columns: NBType.array().of(NBType.timestamp()),
  /* @prop */
  series: NBType.array().of(TimelineSeriesSchema),
  /* @prop */
  timeUnit: NBType.enum(MetricTimeUnit),
  /* @prop */
  noteGroups: NBType.array().of(TimelineAnnotationGroupSchema),
  /* @prop */
  withTimelineAnnotations: NBType.boolean().default(false),
  /* @prop */
  excelNotes: NBType.array().of(TimelineAnnotationGroupSchema)
  /* END */
})

export default TimelineDataSchema
export type TimelineData = InferType<typeof TimelineDataSchema>
